import { JsonServiceClient } from '@servicestack/client';
import { useCallback, useMemo, useState } from 'react';
import { client } from '../api/client';
import { DeleteSponsor, DeleteSponsorResponse } from '../api/dtos';

const serviceStackClient: JsonServiceClient = client;

const url = '/conference/delete';

export const useDeleteSponsor = (id?: number) => {

    const [pending, setPending] = useState<boolean>(false);

    const deleteSponsor = useCallback(async (id?: number) => {

        if(id){
            setPending(true);
    
            const request = new DeleteSponsor();
            request.id = id;
            const response: DeleteSponsorResponse = await serviceStackClient.delete(request);
        
            setPending(false);
    
            return response;
        }

    }, [id]);

    const deleteSponsorService = useMemo(() => {
        return {
            deleteSponsor, 
            pending
        }
    }, [id, pending]);

    return deleteSponsorService;
}

export default useDeleteSponsor;
